/**
 * XML Generator Service
 * Generates XML from form data for demo requests
 */

/**
 * Escapes XML special characters
 * @param {string} text - Text to escape
 * @returns {string} - Escaped text
 */
const escapeXml = (text) => {
  if (!text) return '';
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};

/**
 * Generates XML from demo request form data
 * @param {Object} formData - Form data object
 * @param {string} domain - Full domain name (e.g., geotabcameras.com)
 * @returns {string} - Generated XML string
 */
export const generateDemoRequestXml = (formData, domain) => {
  const timestamp = new Date().toISOString();
  const createdOn = formData.createdOn || new Date().toISOString();
  const requestType = formData.requestType || 'Demo Request';
  
  const xml = `<?xml version="1.0" encoding="UTF-8"?>
<Request>
  <Domain>${escapeXml(domain)}</Domain>
  <TimeStamp>${escapeXml(timestamp)}</TimeStamp>
  <CreatedOn>${escapeXml(createdOn)}</CreatedOn>
  <Name>${escapeXml(formData.name)}</Name>
  <Email>${escapeXml(formData.email)}</Email>
  <Phone>${escapeXml(formData.phone || '')}</Phone>
  <Company>${escapeXml(formData.company || '')}</Company>
  <FleetSize>${escapeXml(formData.fleetSize || '')}</FleetSize>
  <Notes>${escapeXml(formData.notes || '')}</Notes>
  <RequestType>${escapeXml(requestType)}</RequestType>
</Request>`;

  return xml;
};

/**
 * Generates a unique filename for the XML file
 * @param {string} domainId - Domain identifier
 * @param {string} fullName - User's full name
 * @param {string} submitDateTime - Submission datetime in ISO format
 * @param {string} requestType - Type of request (demo, pricing, etc.)
 * @returns {string} - Generated filename
 */
export const generateXmlFilename = (domainId, fullName, submitDateTime, requestType = 'demo') => {
  // Convert full name to hyphenated format
  const nameWithHyphens = fullName
    .toLowerCase()
    .replace(/[^a-zA-Z0-9\s]/g, '') // Remove special characters except spaces
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
  
  // Format datetime for filename (remove colons and dots)
  const formattedDateTime = submitDateTime.replace(/[:.]/g, '-');
  
  return `${requestType}-${nameWithHyphens}-${formattedDateTime}.xml`;
};
